import React, { useState, useRef } from 'react';
import PropTypes from 'prop-types';
import scrollIntoView from 'scroll-into-view';

import {
    readMoreDefaultMessage,
    readLessDefaultMessage,
} from '../../components/global/ExpandableContent/ExpandableContent';
import { ExpandingArea } from 'dibs-elements/exports/ExpandingArea';
import { ReadMoreButton } from '../../components/global/ExpandableContent/ReadMoreButton';

export const PdpSharedDescriptionContent = ({
    collapsedHeight,
    buttonClass,
    children,
    gradientColor,
}) => {
    const [isExpanded, setIsExpanded] = useState(false);
    const [isContentExpandable, setIsContentExpandable] = useState(false);
    const contentRef = useRef(null);
    return (
        <div ref={contentRef}>
            <ExpandingArea
                collapsedHeight={collapsedHeight}
                expanded={isExpanded}
                setIsContentExpandable={setIsContentExpandable}
                gradientColor={gradientColor}
                dataTn="about"
            >
                {children}
            </ExpandingArea>
            {isContentExpandable && (
                <ReadMoreButton
                    isExpanded={isExpanded}
                    className={buttonClass}
                    onClick={() => {
                        if (isExpanded && contentRef && contentRef.current) {
                            scrollIntoView(contentRef.current, { time: 200 });
                        }
                        setIsExpanded(!isExpanded);
                    }}
                    readLessMessage={readLessDefaultMessage}
                    readMoreMessage={readMoreDefaultMessage}
                />
            )}
        </div>
    );
};

PdpSharedDescriptionContent.propTypes = {
    collapsedHeight: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    buttonClass: PropTypes.string,
    children: PropTypes.node,
    gradientColor: PropTypes.string,
};
